import { render, staticRenderFns } from "./DevicesServiceRequestLink.vue?vue&type=template&id=4da4ca90&"
import script from "./DevicesServiceRequestLink.vue?vue&type=script&lang=js&"
export * from "./DevicesServiceRequestLink.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/bamboo-agent-home/xml-data/build-dir/WWW-WWW-JOB1/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4da4ca90')) {
      api.createRecord('4da4ca90', component.options)
    } else {
      api.reload('4da4ca90', component.options)
    }
    module.hot.accept("./DevicesServiceRequestLink.vue?vue&type=template&id=4da4ca90&", function () {
      api.rerender('4da4ca90', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/src/components/myaccount/devices/shared/components/DevicesServiceRequestLink.vue"
export default component.exports